import { makeStyles, useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  '@global': {
    '*': {
      boxSizing: 'border-box',
    },
    body: {
      margin: 0,
      padding: 0,
    }
  },
  root: {
    display: 'flex',
    justifyContent: 'center',
    margin: '30px 0',
    overflowX: 'hidden', 
    [theme.breakpoints.down('sm')]: {
      margin: '20px 0',
    },
    [theme.breakpoints.down('xs')]: {
      margin: '10px 0',
    },
  },
  container: {
    width: '600px',
    maxWidth: '100%', 
    padding: '0 15px', 
    [theme.breakpoints.down('md')]: {
      width: '80%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      padding: '0 10px', 
    },
  },
  title: {
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.2rem',
    },
  },
  paragraph: {
    margin: '15px 0',
    [theme.breakpoints.down('sm')]: {
      margin: '10px 0',
    },
    [theme.breakpoints.down('xs')]: {
      margin: '5px 0',
    },
  },
  listItem: {
    marginBottom: '5px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '3px',
    },
    [theme.breakpoints.down('xs')]: {
      marginBottom: '2px',
    },
  }
}));

export default useStyles;
